import request from '@/router/axios';
//获取未结任务数量
export function getUnfinishedTask(data) {
  return request({
    url: '/api/blade-system/usual/api/getUnFinishTask',
    method: 'post',
    data
  })
}
// 获取动态表单配置和数据的接口
export function getExtColData(params) {
  return request({
    url: '/api/blade-system/usual/api/getExtColData',
    method: 'get',
    params
  })
}
// 获取文书配置
export const getWsConfig = (data) => {
  return request({
    url: '/api/blade-system/usual/api/getWsConfig',
    method: 'post',
    params: data
  })
}
// 修改任务状态
export const updateRwStatus = data => {
  return request({
    url: '/api/blade-xfjd/api/base/updateRwStatus',
    method: 'post',
    data
  })
}
//获取分工信息
export const getDivision = (data) => {
  return request({
    url: "/api/blade-xfjd/api/base/pGetCbr",
    method: "post",
    data,
  })
}
// 点击审批再分工 获取审批信息
export const pLzspFgInfo = (data) => {
  return request({
    url: "/api/blade-xfjd/api/base/pLzspFgInfo",
    method: "post",
    data,
  })
}
// 点击审批获取审批信息
export const pLzspSpInfo = (data) => {
  return request({
    url: "/api/blade-xfjd/api/base/pLzspSpInfo",
    method: "post",
    data,
  })
}
// 点击审批获取审批信息
export const getHcsx = (data) => {
  return request({
    url: "/api/blade-xfjd/api/base/getHcsx",
    method: "post",
    data
  });
}
// 获取审批/发送页面文书列表
export const getFsWsList = (data, obj = {}) => {
  return request({
    url:  '/api/blade-xfjd/api/base/getFsWsList' ,
    method: "post",
    data
  })
}

// 审批拿详情列表的接口
export const getxzcfxmrw = (data) => {
  return request({
    url: "/api/blade-xfjd/api/xzcfxmrw/queryYSPXX",
    method: "post",
    data
  })
}

// 获取 配置  table列表
export const wgetDataByDataId = (current, size, params, cs) => {
  return request({
    url: '/api/blade-system/usual/api/wgetDataByDataId' + (cs || ''),
    method: 'post',
    data: {
      ...params,
      current,
      size,
    }
  })
}


//获取外部系统对接信息
export const getWBXTinfo = (data) => {
  return request({
    url: "/api/blade-system/system/esdd/expesdd",
    method: "post",
    data
  })
}
